import { ViewWorkOrderDetailsModal } from "@/features/orders/workOrders/ViewWorkOrderDetailsModal";
import { type WorkOrderWidgetList } from "@repo/api";
import { LightMode, ListView, ListViewItem } from "@repo/skapa";
import { t, useTranslation } from "@repo/translation";
import { SimpleLabelField, localizeDate } from "@repo/ui";
import { useState } from "react";

interface WorkOrdersListProps {
  workOrders: WorkOrderWidgetList[];
}

export const WorkOrdersList = ({ workOrders }: WorkOrdersListProps) => {
  const { dateFnsLocale } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedWorkOrder, setSelectedWorkOrder] = useState<
    WorkOrderWidgetList | undefined
  >(undefined);
  return (
    <>
      <ListView id="workspace-installation-quotation-list">
        {workOrders.map((workOrder) => (
          <ListViewItem
            key={workOrder.workOrderNumber}
            title={workOrder.projectName ?? ""}
            control="navigational"
            description={
              <SimpleLabelField
                label={t("label.status")}
                value={workOrder.status}
                color={LightMode.colourTextAndIcon2}
                small
              />
            }
            addOn={
              <SimpleLabelField
                label={t("label.installation_start_date")}
                value={
                  workOrder.scheduledStartTime
                    ? localizeDate(workOrder.scheduledStartTime, dateFnsLocale)
                    : "-"
                }
                color={LightMode.colourTextAndIcon3}
                small
              />
            }
            onClick={() => {
              setSelectedWorkOrder(workOrder);
              setIsModalOpen(true);
            }}
          />
        ))}
      </ListView>
      <ViewWorkOrderDetailsModal
        isOpen={isModalOpen && Boolean(selectedWorkOrder)}
        closeModal={() => setIsModalOpen(false)}
        workOrder={selectedWorkOrder}
      />
    </>
  );
};
